import React from 'react';
import classes from './DealerFavoriteButton.module.scss';
import { useDealerFavorites } from '../../store/dealer-favorites-context';

/**
 * Heart toggle for a dealer-stock car. Reads and writes the app-wide saved set
 * (store/dealer-favorites-context.js) so the grid, the detail page and the
 * garage all agree on which cars are saved.
 *
 * Stops the click from reaching the card's link: on the grid it sits on top of
 * an <a>, and a save should never also navigate.
 */
const DealerFavoriteButton = ({ car, className = '', size = 'sm', showLabel = false }) => {
    const { isFavorite, isPending, toggle } = useDealerFavorites();
    const vehicleId = car && car._id;
    const active = !!vehicleId && isFavorite(vehicleId);
    const pending = !!vehicleId && isPending(vehicleId);

    const onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(car);
    };

    return (
        <button
            type="button"
            className={`${classes.button} ${size === 'lg' ? classes.large : ''} ${active ? classes.active : ''} ${className}`}
            onClick={onClick}
            disabled={pending}
            aria-pressed={active}
            aria-label={active ? 'Remove from my garage' : 'Save to my garage'}
            title={active ? 'Remove from my garage' : 'Save to my garage'}
        >
            <i className={`${active ? 'fas' : 'far'} fa-heart`} aria-hidden="true"></i>
            {showLabel && <span>{active ? 'Saved' : 'Save'}</span>}
        </button>
    );
};

export default DealerFavoriteButton;
